package com.imobly.imobly.ui.screens.login

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.systemBars
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Login
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.navigation.compose.rememberNavController
import com.imobly.imobly.ui.components.button.ButtonComp
import com.imobly.imobly.ui.components.input.InputComp
import com.imobly.imobly.ui.components.input.InputPasswordComp
import com.imobly.imobly.ui.components.messageerror.MessageErrorComp
import com.imobly.imobly.ui.components.title.TitleComp
import com.imobly.imobly.ui.theme.colors.BackGroundColor
import com.imobly.imobly.ui.theme.colors.PrimaryColor
import com.imobly.imobly.ui.theme.fonts.montserratFont
import com.imobly.imobly.viewmodel.LoginViewModel
import imobly.composeapp.generated.resources.Res
import imobly.composeapp.generated.resources.image_logo_white
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview

@Composable
fun LoginScreen(loginViewModel: LoginViewModel) {
    val scrollState = rememberScrollState()

    loginViewModel.resetPage()

    MaterialTheme {
        Scaffold(
            topBar = {},
            snackbarHost = {
                SnackbarHost(loginViewModel.snackMessage.value)
            },
            contentWindowInsets = WindowInsets.systemBars
        ) { paddingValues ->
            Box(
                modifier = Modifier
                    .background(PrimaryColor)
                    .padding(paddingValues)
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.Center
                ) {
                    Image(
                        painter = painterResource(Res.drawable.image_logo_white),
                        contentDescription = "Logo do Imobly",
                        modifier = Modifier.size(160.dp)
                    )
                }

                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(top = 160.dp)
                        .background(
                            BackGroundColor,
                            shape = RoundedCornerShape(topStart = 50.dp, topEnd = 50.dp)
                        )
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(scrollState),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {

                        Spacer(Modifier.size(60.dp))
                        TitleComp("Iniciar sessão", { }, false, 40.sp)
                        Spacer(Modifier.size(40.dp))
                        Column(
                            Modifier
                                .widthIn(max = 1000.dp)
                                .fillMaxWidth(0.9f),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            InputComp(
                                label = "E-mail",
                                placeholder = "Ex: joao@dominio.com",
                                value = loginViewModel.email.value,
                                onValueChange = { loginViewModel.changeEmail(it) },
                                isError = loginViewModel.inputContainsError("email"),
                                errorMessage = loginViewModel.getInputErrorMessage("email")
                            )

                            InputPasswordComp(
                                label = "Senha",
                                placeholder = "Ex: ********",
                                value = loginViewModel.password.value,
                                onValueChange = { loginViewModel.changePassword(it) },
                                isError = loginViewModel.inputContainsError("password"),
                                errorMessage = loginViewModel.getInputErrorMessage("password"),
                                passwordVisible = loginViewModel.passwordVisibilityState.value,
                                changePasswordVisible = { loginViewModel.changePasswordVisibility() }
                            )
                        }

                        Column(
                            modifier = Modifier
                                .widthIn(max = 800.dp)
                                .fillMaxWidth(0.8f),
                            horizontalAlignment = Alignment.End
                        ) {
                            Text(
                                "Esqueceu a senha?",
                                fontFamily = montserratFont(),
                                fontWeight = FontWeight.Medium,
                                modifier = Modifier.clickable { loginViewModel.goToForgotPassword() }
                            )
                        }

                        if (loginViewModel.messageError.value != "") {
                            MessageErrorComp(loginViewModel.messageError.value, 16.sp)
                        }
                        ButtonComp(
                            "Entrar",
                            { Icon(Icons.AutoMirrored.Filled.Login, "login") },
                            PrimaryColor,
                            { loginViewModel.signInAction() }
                        )

                        Row(
                            horizontalArrangement = Arrangement.Center,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(vertical = 50.dp)
                        ) {

                            Text(
                                "Não possui conta? ",
                                textAlign = TextAlign.Center,
                                fontFamily = montserratFont(),
                                fontWeight = FontWeight.Medium,
                            )

                            Text(
                                "Cadastre-se",
                                textAlign = TextAlign.Center,
                                fontFamily = montserratFont(),
                                fontWeight = FontWeight.SemiBold,
                                modifier = Modifier.clickable { loginViewModel.goToSignUp() }
                            )

                        }
                    }
                }
            }
        }
    }
}

@Composable
@Preview
fun LoginScreenPreview() {
    val navControllerFake = rememberNavController()
    LoginScreen(LoginViewModel(navControllerFake))
}
